const constants = {
  BASE_URL: process.env.REACT_APP_BASE_URL as string,
  EB_APP_URL: process.env.REACT_APP_WEB_APP_URL
};

export default constants;
